import { render, staticRenderFns } from "./DialogAddEdit.vue?vue&type=template&id=7d879fb8&scoped=true&"
import script from "./DialogAddEdit.vue?vue&type=script&lang=js&"
export * from "./DialogAddEdit.vue?vue&type=script&lang=js&"
import style0 from "./DialogAddEdit.vue?vue&type=style&index=0&id=7d879fb8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d879fb8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wp/Desktop/chuanti-pc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d879fb8')) {
      api.createRecord('7d879fb8', component.options)
    } else {
      api.reload('7d879fb8', component.options)
    }
    module.hot.accept("./DialogAddEdit.vue?vue&type=template&id=7d879fb8&scoped=true&", function () {
      api.rerender('7d879fb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/pcManage/depthManage/components/DialogAddEdit.vue"
export default component.exports